import { render, staticRenderFns } from "./BackTo.vue?vue&type=template&id=219b63d6&scoped=true&"
import script from "./BackTo.vue?vue&type=script&lang=js&"
export * from "./BackTo.vue?vue&type=script&lang=js&"
import style0 from "./BackTo.vue?vue&type=style&index=0&id=219b63d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219b63d6",
  null
  
)

export default component.exports